import type { EntityTag } from "@/types/entity-tag";

/**
 * What the components in this folder need of a tag.
 *
 * Derived from `EntityTag` rather than re-declared, so the fields have one
 * definition. Narrowed to the display fields: nothing here renders timestamps,
 * and asking for them would stop a caller passing a partially-built tag.
 * No retirement flag: both catalogs leave archived tags out server-side.
 */
export type TagLike = Pick<EntityTag, "id" | "name" | "emoji" | "color">;

/** Swatch colour for a tag carrying neither emoji nor colour. */
export const TAG_DEFAULT_COLOR = "#6B7280";
